import React, { useState } from 'react'
import "./Stay.css"
import { openBooking } from '../../app/utils/links'
const gallery = [
    {
        id: 1,
        img: require("../../app/assets/images/stone-cottage.webp"),
    },
    {
        id: 2,
        img: require("../../app/assets/images/8.webp"),
    },
    {
        id: 3,
        img: require("../../app/assets/images/9.webp"),
    },
    {
        id: 4,
        img: require("../../app/assets/images/gallery/gallery-7.webp"),
    },
    {
        id: 5,
        img: require("../../app/assets/images/cottage-imgs.webp"),
    },
     {
        id: 6,
        img: require("../../app/assets/images/cottage-imgs-2.webp"),
    },
     {
        id: 7,
        img: require("../../app/assets/images/cottage-imgs-4.webp"),
    },
     {
        id: 8,
        img: require("../../app/assets/images/cottage-imgs-5.webp"),
    },
    {
        id: 9,
        img: require("../../app/assets/images/cottage-imgs-7.jpeg"),
    },
     {
        id: 10,
        img: require("../../app/assets/images/gallery/gallery-6.webp"),
    },
     {
        id: 11,
        img: require("../../app/assets/images/cottage-imgs-9.jpeg"),
    },
     {
        id: 12,
        img: require("../../app/assets/images/gallery/gallery-13.webp"),
    },
    {
        id: 13,
        img: require("../../app/assets/images/gallery/gallery-24.webp"),
    },
    {
        id: 14,
        img: require("../../app/assets/images/gallery/gallery-25.webp"),
    },
    {
        id: 15,
        img: require("../../app/assets/images/gallery/gallery-35.webp"),
    },
    {
        id: 16,
        img: require("../../app/assets/images/gallery/gallery-39.webp"),
    },
    {
        id: 17,
        img: require("../../app/assets/images/gallery/gallery-44.jpeg"),
    },
    {
        id: 18,
        img: require("../../app/assets/images/gallery/gallery-47.jpeg"),
    },
    {
        id: 19,
        img: require("../../app/assets/images/gallery/gallery-48.jpeg"),
    },
    {
        id: 20,
        img: require("../../app/assets/images/gallery/gallery-49.jpeg"),
    },
    {
        id: 21,
        img: require("../../app/assets/images/gallery/gallery-51.jpeg"),
    },
    {
        id: 22,
        img: require("../../app/assets/images/gallery/gallery-53.webp"),
    },
    {
        id: 23,
        img: require("../../app/assets/images/gallery/gallery-56.webp"),
    },
    {
        id: 24,
        img: require("../../app/assets/images/gallery/gallery-64.webp"),
    },
    {
        id: 25,
        img: require("../../app/assets/images/bathroom.jpeg"),
    },
    {
        id: 26,
        img: require("../../app/assets/images/cottage-night-img.jpeg"),
    },
    {
        id: 27,
        img: require("../../app/assets/images/cottage-imgs-1.jpeg"),
    },
    {
        id: 28,
        img: require("../../app/assets/images/bathroom-2.jpeg"),
    },
    {
        id: 29,
        img: require("../../app/assets/images/cottage-imgs-10.webp"),
    },
    {
        id: 30,
        img: require("../../app/assets/images/cottage-imgs-11.webp"),
    },
    {
        id: 31,
        img: require("../../app/assets/images/cottage-imgs-12.webp"),
    },
    {
        id: 32,
        img: require("../../app/assets/images/cottage-imgs-13.webp"),
    },
    {
        id: 33,
        img: require("../../app/assets/images/gallery/gallery-43.jpeg"),
    },
    {
        id: 34,
        img: require("../../app/assets/images/cottage-imgs-15.webp"),
    },
    {
        id: 35,
        img: require("../../app/assets/images/cottage-imgs-16.webp"),
    },
    {
        id: 36,
        img: require("../../app/assets/images/cottage-imgs-17.jpeg"),
    },
    {
        id: 37,
        img: require("../../app/assets/images/cottage-imgs-18.jpeg"),
    },
    {
        id: 38,
        img: require("../../app/assets/images/cottage-imgs-19.webp"),
    },
    {
        id: 39,
        img: require("../../app/assets/images/cottage-imgs-20.webp"),
    },
]

function Stay() {
 

    return (
        <>
            <section className="hero-section banner_sec">
                <div className="container">
                    <div className='banner-wraper'>
                        <h1 className="banner-heading">Stay in <span>Nature</span></h1>
                        <p className='banner-sub-heading'>Eco-friendly forest stays in Corbett National Park.</p>
                        <p className="content text-white">
                           Our mud and stone cottages are designed to blend into the landscape - simple, grounded, and climate responsive. Built using local materials and traditional techniques, they offer comfort without disconnecting you from nature. Whether you’re resting on a verandah overlooking the forest or sharing meals made from local produce, your stay becomes part of the experience itself.
                        </p>
                    </div>
                </div>
            </section>

            {/* Mud Cottages Section */}
            <section className="section-padding" id="cottages" style={{ scrollMarginTop: "110px" }}>
                <div className='container'>
                    <div className='box-wraper'>
                        <div className="row align-items-center mb-5">
                            <div className="col-md-6 mb-4 mb-md-0">
                                <img loading="lazy" decoding="async" src={require("../../app/assets/images/mud-cottages.webp")} alt="Mud Cottage" className="cottage-img" />
                            </div>
                            <div className="col-md-6 ps-md-5">
                                <p className="top-heading text-uppercase">Rustic & Sustainable</p>
                                <h2 className="heading">Mud Cottages</h2>
                                <p className='content'>Earth-built, climate-friendly living spaces blending with the landscape. Naturally cool and comfortable, built using local materials and traditional techniques.</p>
                                <ul className="arrow-list">
                                    <li><strong>Capacity:</strong> 2 Adults + 1 Child</li>
                                    <li><strong>Best suited for:</strong> Couples and Solo Travelers seeking peace.</li>
                                    <li><strong>Features:</strong> Private Sit-out, Solar Lighting, Organic Linens.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="row align-items-center flex-column-reverse flex-md-row box-wraper">
                            <div className="col-md-6 pe-md-5">
                                <p className="top-heading text-uppercase">Elegant & Earthy</p>
                                <h2 className="heading">Stone Cottages</h2>
                                <p className='content'>Rustic. Grounded. Comfortable. <br />
                                    Nature cottage near Corbett | Kumaoni architecture | Village style stay
                                    Uttarakhand - <strong>These are not exactly village style but more modern I would say! So we may change the description as they look once we have the pics in place.</strong> </p>
                                <ul className="arrow-list mb-4">
                                    <li><strong>Capacity:</strong> 3 Adults or Family of 4</li>
                                    <li><strong>Features:</strong> Large Windows, Rainforest Shower, Forest Views.</li>
                                </ul>
                            </div>
                            <div className="col-md-6 mb-4 mb-md-0">
                                <img loading="lazy" decoding="async" src={require("../../app/assets/images/kyari-cottage.webp")} alt="Stone Cottage" className="cottage-img" />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center gap-3">
                        <button className="primary_btn" onClick={openBooking}>Check Availability</button>
                        <button className="outline_btn" onClick={openBooking}>Choose Your Cottage</button>
                    </div>
                </div>
            </section>


            {/* Dining Section */}
            <section className="section-padding bg-light-custom">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-5">
                            <h2 className="heading">Dining at the Camp</h2>
                            <p className="content">Fresh. Seasonal. Thoughtfully Curated.</p>
                            <p className='content'>Our fixed buffet changes with the season and the guests we host, bringing together Kumaoni specialities, Indian favourites, and occasional global influences. Prepared with fresh ingredients and simple recipes, every meal is wholesome, comforting, and meant to be shared.</p>
                            <ul className="circle-list mt-4">
                                <li>Seasonal, rotating buffet</li>
                                <li>Regional and Indian favourites</li>
                                <li>Fresh, home-style cooking</li>
                            </ul>
                        </div>
                        <div className="col-md-7">
                            <img loading="lazy" decoding="async" src={require("../../app/assets/images/dining-camp.webp")} alt="Dining" className="cottage-img shadow" />
                        </div>
                    </div>
                </div>
            </section>

            {/* Gallery Section */}
            <section className="section-padding container">
                <div className="d-flex justify-content-between align-items-end mb-4 flex-wrap">
                    <h2 className="fw-bold">The Gallery</h2>

                    {/* <nav className="gallery-nav mt-3 mt-md-0 d-flex gap-3 flex-wrap">
                        {Object.keys(galleryData).map((tab) => (
                            <a
                                key={tab}
                                onClick={() => setActiveTab(tab)}
                                className={activeTab === tab ? "active" : ""}
                                style={{ cursor: "pointer" }}
                            >
                                {tab}
                            </a>
                        ))}
                    </nav> */}
                </div>

                <div className="row g-3">
                    {gallery.map((item) => (
                        <div key={item.id} className="col-6 col-md-4">
                            <img loading="lazy" decoding="async"
                                src={item.img}
                                alt="Gallery"
                                className="gallery-img"
                            />
                        </div>
                    ))}
                </div>
            </section>
        </>
    )
}

export default Stay